import { GIG_GRID_LRG, GIG_GRID_MED, GIG_GRID_SML, GIG_GRID_XLRG } from '../../shared/Grid';

export const RECENTLY_VIEWED_SOURCE = 'your_recently_viewed_gigs';

export const sliderBaseNum = 8;

export const sliderBreakpoints = [
    {
        breakpoint: GIG_GRID_XLRG,
        slides: 6
    },
    {
        breakpoint: GIG_GRID_LRG,
        slides: 5
    },
    {
        breakpoint: GIG_GRID_MED,
        slides: 4
    },
    {
        breakpoint: GIG_GRID_SML,
        slides: 2
    }
];
